(function () {
  'use strict';
  var frames = ['SFDS08','SFDS09','SFPR09','SFPR10','SFRX09','SFTX09','SFYM08','SFYM09','SFYM10'];
  function classify(sku) {
    var bits = String(sku || '').toUpperCase().split('-');
    if (/^SC002[0-9]$/.test(bits[0]) && bits.length === 1) return {kind:'cushions'};
    if (frames.indexOf(bits[0]) !== -1 && bits.length === 1) return {kind:'frame',frame:bits[0]};
    if (bits[0] === 'BNDL' && frames.indexOf(bits[1]) !== -1 && /^SC\d{4}$/.test(bits[2] || '') && (bits.length === 3 || (bits.length === 4 && /^AR\d{4}$/.test(bits[3])))) {
      return {kind: bits.length === 4 ? 'seat-arm' : 'seat', frame:bits[1],cushion:bits[2],arm:bits[3] || ''};
    }
    return {kind:''};
  }
  function hasArms(items) {
    return (items || []).some(function (item) {
      return /(^|-)AR\d{4}($|-)/i.test(item.sku || '') || /arm\s*rest/i.test(item.product_title || item.title || '');
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {classify:classify,hasArms:hasArms};
  if (typeof document === 'undefined' || window.WgcSetup) return;
  var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartCache = null, cartFlight = null;
  function json(url, options) {
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 12000);
    return fetch(url, Object.assign({credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal}, options || {}))
      .then(function (r) { return r.json().then(function (body) { if (!r.ok) throw new Error(body.description || body.message || 'Could not complete this request.'); return body; }); })
      .finally(function () { clearTimeout(timeout); });
  }
  function fetchCart() {
    if (cartFlight) return cartFlight;
    cartFlight = json(rootPath + 'cart.js').then(function (cart) { cartCache = cart; return cart; }).finally(function () { cartFlight = null; });
    return cartFlight;
  }
  function selected(box) {
    var productRoot = box.closest('[data-section-type="product"]');
    if (!productRoot) return null;
    var el = productRoot.querySelector('script[id^="ProductJson-"]');
    if (!el) el = document.querySelector('script[id^="ProductJson-"]');
    var p; try { p = JSON.parse(el.textContent); } catch (e) { return null; }
    var input = productRoot.querySelector('[name="id"]'), options = productRoot.querySelectorAll('.single-option-selector');
    return (p.variants || []).find(function (v) {
      if (options.length) return options.length === v.options.length && Array.from(options).every(function (o, i) { return o.value === v.options[i]; });
      return input && String(v.id) === String(input.value);
    }) || null;
  }
  function titleAndContents(box) {
    var v = selected(box), kind = v ? classify(v.sku) : {kind:''};
    var heading = box.querySelector('[data-setup-heading]'), text = box.querySelector('[data-setup-includes]'), note = box.querySelector('[data-setup-note]');
    if (!heading || !text || !note) return;
    if (box.dataset.setupElectrical === 'true') return;
    var known = !!kind.kind;
    box.hidden = !known;
    if (!known) return;
    if (kind.kind === 'cushions') {
      heading.textContent = 'Refresh your existing NOMAD seating';
      text.textContent = 'Includes one seat-bottom cushion and one matching backrest cushion.';
      note.textContent = 'Cushions only. Seat frame, flip-seat mechanism, footrest and grab bar are not included. Check dimensions and mounting before ordering.';
    } else if (kind.kind === 'frame') {
      heading.textContent = 'NOMAD frame only';
      text.textContent = 'This is the model-specific frame assembly listed below.';
      note.textContent = 'Seat cushions and armrests are sold separately. Review the included hardware and roof-support requirements.';
    } else {
      heading.textContent = 'Your NOMAD seat setup';
      text.textContent = kind.kind === 'seat-arm' ? 'Includes the model-specific rear flip-seat kit, selected rear cushions and one armrest pair (' + kind.arm + ').' : 'Includes the model-specific rear flip-seat kit and selected rear cushions. Optional armrests are sold separately.';
      note.textContent = 'Review your cart generation, mounting and roof-support requirements below.';
    }
    var controls = box.querySelector('[data-setup-options]');
    if (controls) controls.dataset.eligible = String(!!v && v.available && (kind.kind === 'seat' || kind.kind === 'frame'));
  }
  function paintOptions() {
    document.querySelectorAll('[data-setup-options]').forEach(function (panel) {
      var productBox = panel.closest('[data-wgc-setup]');
      if (productBox) titleAndContents(productBox);
      var show = panel.dataset.eligible === 'true' && cartCache && !hasArms(cartCache.items);
      panel.hidden = !show;
    });
  }
  function showContents(box) {
    var host = box.closest('[data-section-type="product"]'), source = host && host.querySelector('.product-single__description');
    var details = box.querySelector('[data-setup-contents]'), list = box.querySelector('[data-setup-contents-list]');
    if (!source || !details || !list) return;
    var headings = Array.from(source.querySelectorAll('h2,h3,h4'));
    var hit = headings.find(function (h) { return /^(what[’']?s included|what is included|bundle contents|included in this bundle|includes\s*&\s*features)\s*:?$/i.test(h.textContent.trim()); });
    if (!hit) return;
    var next = hit.nextElementSibling;
    while (next && !/^H[1-6]$/.test(next.tagName) && !/^(UL|OL)$/.test(next.tagName)) next = next.nextElementSibling;
    if (!next || !/^(UL|OL)$/.test(next.tagName)) return;
    list.replaceChildren();
    Array.from(next.children).filter(function (n) { return n.tagName === 'LI'; }).forEach(function (n) { var li = document.createElement('li'); li.textContent = n.textContent.trim(); list.appendChild(li); });
    details.hidden = !list.children.length;
  }
  function bindProduct(box) {
    if (box.dataset.bound) return;
    box.dataset.bound = 'true';
    var productRoot = box.closest('[data-section-type="product"]');
    if (!productRoot) return;
    // Move the compact decision summary beside the purchase controls, without replacing their form or listeners.
    var buy = productRoot.querySelector('.free-ship-msg');
    if (buy) buy.parentNode.insertBefore(box, buy);
    showContents(box);
    function update() { titleAndContents(box); paintOptions(); }
    productRoot.addEventListener('change', function () { setTimeout(update,0); });
    document.addEventListener('variant:change', function () { setTimeout(update,0); });
    update();
    var badge = productRoot.querySelector('.jdgm-prev-badge[data-number-of-reviews]'), proof = box.querySelector('[data-setup-proof]');
    if (badge && proof && Number(badge.getAttribute('data-number-of-reviews')) > 0) proof.hidden = false;
  }
  function money(cents, currency) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:currency || 'USD'}).format(Number(cents)/100); }
  function bindCartAdd(button) {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.addEventListener('click', async function () {
      var panel = button.closest('[data-setup-options]'), message = panel.querySelector('[data-setup-message]');
      var form = button.closest('form'), dirty = form && Array.from(form.querySelectorAll('.cart-qty')).some(function (i) { return i.value !== i.defaultValue; });
      if (dirty) { message.textContent = 'Update your cart quantities before adding this accessory.'; return; }
      if (button.disabled) return;
      button.disabled = true; message.textContent = 'Checking current price and availability…';
      var postStarted = false;
      try {
        var cart = await fetchCart();
        if (hasArms(cart.items)) { paintOptions(); return; }
        if (!cart.items.some(function (i) { var c = classify(i.sku); return c.kind === 'seat' || c.kind === 'frame'; })) { panel.hidden = true; return; }
        var p = await json(rootPath + 'products/' + encodeURIComponent(button.dataset.handle) + '.js');
        var matches = (p.variants || []).filter(function (variant) { return variant.sku === button.dataset.sku; });
        if (matches.length !== 1) throw new Error('Exact accessory SKU could not be matched.');
        var v = matches[0];
        if (!v.available) { message.textContent = 'This accessory is currently unavailable. Your cart has not changed.'; button.hidden = true; return; }
        if (Number(button.dataset.price) !== Number(v.price)) {
          button.dataset.price = String(v.price);
          panel.querySelector('[data-setup-option-price]').textContent = money(v.price, cart.currency);
          button.textContent = 'Add 1 pair — ' + money(v.price,cart.currency);
          message.textContent = 'The price has changed. Review the updated price, then choose Add to confirm.'; return;
        }
        postStarted = true;
        await json(rootPath + 'cart/add.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});
        document.dispatchEvent(new CustomEvent('wgc:cart-updated'));
        window.location.reload();
      } catch (error) {
        message.textContent = postStarted ? 'The add could not be confirmed. Refresh your cart before trying again to avoid a duplicate.' : 'Could not check this accessory. Your cart has not changed; you can still check out.';
        if (postStarted) button.hidden = true;
      } finally { button.disabled = false; }
    });
  }
  function init() {
    document.querySelectorAll('[data-wgc-setup]').forEach(bindProduct);
    document.querySelectorAll('[data-setup-add]').forEach(bindCartAdd);
    if (document.querySelector('[data-setup-options]')) fetchCart().then(paintOptions).catch(function () { document.querySelectorAll('[data-setup-options]').forEach(function (p) { p.hidden = true; }); });
  }
  ['wgc:cart-updated','cart:updated','cart:change','ajaxProduct:added'].forEach(function (event) { document.addEventListener(event, function () { if (document.querySelector('[data-setup-options]')) fetchCart().then(paintOptions).catch(function () {}); }); });
  var popup = document.querySelector('[data-cart-popup-wrapper]');
  if (popup) new MutationObserver(function () { if (!popup.classList.contains('cart-popup-wrapper--hidden')) fetchCart().then(paintOptions).catch(function () {}); }).observe(popup,{attributes:true,attributeFilter:['class']});
  window.WgcSetup = {classify:classify,hasArms:hasArms};
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow',function (e) { if (e.persisted) init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
